import { FC, ReactNode, useEffect, useState } from 'react';
import { reloadHeaderFinished } from '../../store/header/actions';
import { useDispatch } from 'react-redux';

type Props = {
    readonly reload?: boolean;
    readonly firstHeaderReload?: boolean;
    readonly children: ReactNode;
};

export const HeaderWrapper: FC<Props> = ({ reload = false, children }) => {
    const dispatch = useDispatch();
    const [showHeader, setShowHeader] = useState(true);

    useEffect(() => {
        if (reload) {
            dispatch(reloadHeaderFinished());
            !showHeader && setShowHeader(true);
        }
    }, [dispatch, reload, showHeader]);

    return showHeader ? <>{children}</> : null;
};
